/* unplugin-vue-components disabled */import { render } from "./NetNotice.vue?vue&type=template&id=4e2568ff&scoped=true"
import script from "./NetNotice.vue?vue&type=script&lang=js"
export * from "./NetNotice.vue?vue&type=script&lang=js"

import "./NetNotice.vue?vue&type=style&index=0&id=4e2568ff&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/mianjuyry-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e2568ff"]])

export default __exports__